import { render } from "./ContentDetailTabungan.vue?vue&type=template&id=b218e0da&scoped=true"
import script from "./ContentDetailTabungan.vue?vue&type=script&lang=js"
export * from "./ContentDetailTabungan.vue?vue&type=script&lang=js"

import "./ContentDetailTabungan.vue?vue&type=style&index=0&id=b218e0da&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b218e0da"]])

export default __exports__